import { GlFormGroup, GlFormInput, GlLink, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'SidebarColorPicker',
    components: {
        GlFormInput,
        GlLink,
        GlFormGroup
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        value: {
            type: String,
            required: false,
            default: ''
        },
        errorMessage: {
            type: String,
            required: false,
            default: ''
        },
        suggestedColors: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'input'
    ],
    computed: {
        selectedColor: {
            get () {
                return this.value;
            },
            set (color) {
                this.handleColorClick(color);
            }
        },
        validColor () {
            return !this.errorMessage;
        }
    },
    methods: {
        handleColorClick (color) {
            this.$emit('input', color);
        },
        getColorCode (color) {
            return Object.keys(color).pop();
        },
        getColorName (color) {
            return Object.values(color).pop();
        },
        getStyle (color) {
            return {
                backgroundColor: this.getColorCode(color)
            };
        }
    }
};
